import "./AccountSelectComponent.scss";
import template from "./AccountSelectComponent.html";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {AccountSource} from "../../types/AccountSource";
import {BehaviorSubject, ReplaySubject, Scheduler, Subject} from "rxjs";
import {AccountStore} from "../../store/AccountStore";
import {Consumer} from "../../../types/GenericTypes";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const AccountSelect = "tfAccountSelect";

export function accountSelect(): IComponentOptions {
    return {
        template,
        transclude: true,
        bindings: {
            source: "<",
            hideSearchIcon: "<",
            hideArrowButton: "<",
        },
        controllerAs: "ctrl",
        controller: AccountSelectComponentController
    };
}

export class AccountSelectComponentController implements IOnInit, IOnDestroy {

    /** @input */
    public set source(source: AccountSource | null) {
        if (source == null) {
            this.source$.next(this.accountStore);
        } else {
            this.source$.next(source);
        }
    }

    public hideSearchIcon: boolean | null;

    public hideArrowButton: boolean | null;

    private readonly source$ = new BehaviorSubject<AccountSource>(this.accountStore);

    public readonly visible$ = new BehaviorSubject(true);

    public readonly showSearch$ = new BehaviorSubject(false);
    public readonly showSelect$ = new BehaviorSubject(false);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly accountStore: AccountStore,
                       private readonly currentUserService: CurrentUserService) {

    }

    public $onInit(): void {
        this.source$
            .observeOn(Scheduler.async)
            .takeUntil(this.destroyed$)
            .distinctUntilChanged()
            .subscribe(this.watchSource());
    }

    private watchSource(): Consumer<AccountSource> {
        const sourceChanged$ = new Subject<boolean>();
        return (source) => {
            sourceChanged$.next(true);
            const accountCount$ = source.accounts
                                        .takeUntil(sourceChanged$)
                                        .map((accounts) => accounts.length)
                                        .shareReplay(1);
            accountCount$.map((count) => count > 1 || (count > 0 && !this.currentUserService.isClient()))
                         .subscribe((visible) => this.visible$.next(visible));
            accountCount$.map((count) => count > 15)
                         .subscribe((manyAccounts) => {
                             this.showSearch$.next(manyAccounts);
                             this.showSelect$.next(!manyAccounts);
                         });
        };
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
